module.exports = __webpack_public_path__ + "static/media/toothbrush.a8a07428.svg";